export default __webpack_public_path__ + "static/media/absentAtt.0e25f637.svg";